/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';

// redux
import { useSelector, useDispatch } from "react-redux";
import {updateCachedInvoiceConfig} from "../../../../../state/slices/settings";
import { SingleSelectDropDown } from "@insticator/insticator-ui";

// material
import {Switch} from "@insticator/insticator-ui";
import SectionGroupDescription
  from "../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription";
import SectionGroup from "../../../../../material/expandablesection/sectiongroup/sectiongroup";
import SectionCard from "../../../../../material/expandablesection/sectioncard/sectioncard";
import InputForm from "../../../../../material/inputform/inputForm";

// utils
import {preventPasteNegative, preventSymbols} from "./utils/functions";

// styles
import injectSheet from "react-jss";
import styles from './advanced_styles';

// static
const SECTION_TITLE = 'Invoice Management'
const SHOW_INVOICE_DESCRIPTION = 'Make invoices available within the Publisher Portal. Invoices are for OKO Full Ad Management accounts only'
const ENABLE_VAT_DESCRIPTION = 'Include the EMEA VAT Tax in our revenue distribution and show the amount on the invoice. The tax rate below will be applicable at the account level and for all products.'
const CURRENCY_CODE_DESCRIPTION = 'Select the currency for the invoices'

/* ========== ~~~~~~~~~~ INVOICE MANAGEMENT ~~~~~~~~~~ ========== */
const InvoiceManagement = injectSheet(styles)((props) => {
  const dispatch = useDispatch()
  const invoiceConfig = useSelector((state) => state.settings.invoiceConfig)

  const handleClick = (target, val) => {
    let newInvoiceConfig = {...invoiceConfig}
    newInvoiceConfig[target] = val;
    dispatch(updateCachedInvoiceConfig(newInvoiceConfig))
  }

  const handleSelect = (currency) => {
    let newInvoiceConfig = {...invoiceConfig}
    newInvoiceConfig['currencyCode'] = currency.name;
    dispatch(updateCachedInvoiceConfig(newInvoiceConfig));
  }

  const handleInvoiceConfigChange = (e) => {
    const target = e.target.name;
    let val = e.target.value;
    if (e.target.name === 'vatRate') {
      val = (val.indexOf(".") >= 0)
        ? (val.substr(0, val.indexOf(".")) + val.substr(val.indexOf("."), 3))
        : val;
      if (val > 100 || val.includes("-")) {
        return;
      }
    }

    let newInvoiceConfig = {...invoiceConfig};
    newInvoiceConfig[target] = val;
    dispatch(updateCachedInvoiceConfig(newInvoiceConfig))
  }

  const SwitchText = (key, title, on) => (
    <div className="flexHorizontal">
      <Switch
        value={key}
        variant={'primary'}
        on={on}
        handleClick={handleClick}
      />
      <SectionGroupDescription
        title={title}
      />
    </div>
  )

  const currencies = [{
    name: 'USD',
    text: ''
  }, {
    name: 'GBP',
    text: ''
  }]

  const CurrencySelect = (title, on) => (
      <div className="flexHorizontal">
        <SectionGroupDescription
            title={title}
        />
        <SingleSelectDropDown
            name={invoiceConfig.currencyCode || 'USD'}
            items={currencies}
            onSelect={currency => handleSelect(currency)}
            selected={currencies.find(currency => currency.name === invoiceConfig.currencyCode)}
            searchable={false}
        />
      </div>
  )

  /*************** COMPONENT ***************/
  return (
    <SectionCard>
      <div className="configWrapper">
        <SectionGroup>
          <SectionGroupDescription title={SECTION_TITLE}/>
        </SectionGroup>
        <SectionGroup>
          <SectionGroupDescription
              title={CurrencySelect('Currency', invoiceConfig.currencyCode)}
              description={CURRENCY_CODE_DESCRIPTION}
          />
        </SectionGroup>
        <SectionGroup>
          <SectionGroupDescription
            title={SwitchText('enableVat', 'VAT Rate', invoiceConfig.enableVat)}
            description={ENABLE_VAT_DESCRIPTION}
          />
        </SectionGroup>
        {invoiceConfig.enableVat && <>
          <SectionGroup>
            <SectionGroupDescription
              title='VAT Rate'
              description=<InputForm name={'vatRate'}
                                     value={invoiceConfig.vatRate}
                                     isNumber={true}
                                     handleChange={handleInvoiceConfigChange}
                                     handlePaste={preventPasteNegative}
                                     handleKeyPress={preventSymbols}
                          />
            />
          </SectionGroup>
          <SectionGroup>
            <SectionGroupDescription
              title='VAT Registration Number'
              description=<InputForm name={'vatRegistrationNumber'}
                                     klass={'textStyle'}
                                     value={invoiceConfig.vatRegistrationNumber}
                                     isNumber={false}
                                     handleChange={handleInvoiceConfigChange}/>
            />
          </SectionGroup>
        </>}
      </div>
    </SectionCard>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default InvoiceManagement;
